import API, { IDENTITY_API } from '../../helpers/api'

const updateSettings = async (settings: {
  email: string
  phoneNumber: string
  missedCallAlerts: string
  receivedSmsAlerts: string
  missedCallAlertRecipients: string
}) => {
  await API.put({
    api: IDENTITY_API,
    url: 'user/settings',
    data: {
      email: settings.email,
      phoneNumber: settings.phoneNumber,
      missedCallAlerts: settings.missedCallAlerts,
      receivedSmsAlerts: settings.receivedSmsAlerts,
      missedCallAlertRecipients: settings.missedCallAlertRecipients,
    },
  })

  return true
}

export default updateSettings
